import React from "react";
import {
  TipoDivergenciaComponent,
  TipoDivergenciaComponentProps,
} from "../../TiposDeDivergencias";
import UploadStepTemplate from "../../template/UploadStepTemplate";


import { MaterialSelectItem } from "../../template/UseGetMateriais";
import QuantidadeTecidoTrianguladoFinalStep from "../materia-prima/quantidade-tecido-triangulado/QuantidadeTecidoTrianguladoFinalStep";

interface UploadQuantidadeProps extends TipoDivergenciaComponentProps {
  payload: { materiais: MaterialSelectItem[]; problemDescription: string };
  onBackComponent: TipoDivergenciaComponent;
}

const UploadQuantidadeTecidoTrianguladoStep: TipoDivergenciaComponent<
  UploadQuantidadeProps
> = ({ onBack, onSetStep, payload, onBackComponent }) => {
  const stepNumber = "2";
  const stepSubTitle = "Anexe uma evidência (ex: foto da nota fiscal) para prosseguir.";
  const stepTitle = "A imagem para este tipo de chamado é obrigatória";

  const onBackHandler = () => {
    onBack({
      component: onBackComponent || UploadQuantidadeTecidoTrianguladoStep,
      payload: payload,
    });
  };
  
  return (
    <UploadStepTemplate
      header={{ title: stepTitle, subtitle: stepSubTitle, step: stepNumber }}
      nextStepComponent={QuantidadeTecidoTrianguladoFinalStep as TipoDivergenciaComponent}
      onBack={onBackHandler}
      onSetStep={onSetStep}
      payload={payload}
      onClose={() => { }}
    />
  );
};

export default UploadQuantidadeTecidoTrianguladoStep;
